import React from 'react';
import ReactDOM from 'react-dom/client'; // 🔥 новый API
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';

// ❌ УДАЛИТЬ bootstrap
// import 'bootstrap/dist/css/bootstrap.min.css';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router>
    <App />
  </Router>
);